module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.crSelectionLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.crSelectionLoading),
      expression: "!crSelectionLoading"
    }],
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "header": "File Search Sites"
    }
  }, [(!_vm.formDisabled) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('button', {
    staticClass: "btn btn-default col-md-2 col-md-offset-8",
    on: {
      "click": function($event) {
        _vm.selectAll()
      }
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectdRecordingTypeId),
      expression: "selectdRecordingTypeId"
    }],
    staticClass: "form-control pull-right",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectdRecordingTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.recordingTypeList), function(recordingType) {
    return _c('option', {
      key: recordingType.id,
      domProps: {
        "value": recordingType.id
      }
    }, [_vm._v("\n                                    " + _vm._s(recordingType.description) + "\n                                ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('v-client-table', {
    ref: "existingSiteGrid",
    attrs: {
      "data": _vm.existingSiteList,
      "columns": _vm.siteListGridSpecColumns,
      "options": _vm.siteListGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.selectedRecordingList),
            expression: "selectedRecordingList"
          }],
          attrs: {
            "type": "checkbox",
            "id": props.row.culturalResourceRecordingId
          },
          domProps: {
            "value": props.row.culturalResourceRecordingId,
            "checked": Array.isArray(_vm.selectedRecordingList) ? _vm._i(_vm.selectedRecordingList, props.row.culturalResourceRecordingId) > -1 : (_vm.selectedRecordingList)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.selectedRecordingList,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = props.row.culturalResourceRecordingId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.selectedRecordingList = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.selectedRecordingList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selectedRecordingList = $$c
              }
            }
          }
        })]) : _vm._e()]
      }
    }, {
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.hasWorkflow && (!_vm.formDisabled || _vm.isShpoCrNorm || _vm.hasShpoRcDeskReview)),
            expression: "props.row.hasWorkflow && (!formDisabled || isShpoCrNorm || hasShpoRcDeskReview)"
          }],
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "recordingType",
      fn: function(props) {
        return [_c('div', [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.recordingTypeId),
            expression: "props.row.recordingTypeId"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": (
              _vm.formDisabled && //formDisabled passed from investigation
              !_vm.isShpoCrNorm && //is not Shpo Cr Normalization 
              !(_vm.hasShpoRcDeskReview && (
                //excludedRecordingTypes.includes(Number(props.row.recordingTypeId)) ||
                //props.row.recordingTypeId === recordingTypeEnum.InternalReview ||
                !props.row.hasWorkflow ||
                !props.row.recordingTypeId)) //is not (SHPO RC Review and don't have worflow)
            )
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(props.row, "recordingTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, function($event) {
              _vm.markChanged(props.row.culturalResourceRecordingId, $event)
            }]
          }
        }, [_c('option', {
          attrs: {
            "value": "",
            "disabled": true
          }
        }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.recordingTypeList), function(recordingType) {
          return _c('option', {
            key: recordingType.id,
            attrs: {
              "disabled": _vm.existingSiteOptionIsDisabled(recordingType.id, props.row.recordingTypeId)
            },
            domProps: {
              "value": recordingType.id
            }
          }, [_vm._v("\n                                        " + _vm._s(recordingType.description) + "\n                                    ")])
        })], 2)])]
      }
    }, {
      key: "isApe",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.isApe),
            expression: "props.row.isApe"
          }],
          attrs: {
            "type": "checkbox",
            "disabled": (props.row.recordingTypeId === 7) || _vm.formDisabled
          },
          domProps: {
            "checked": Array.isArray(props.row.isApe) ? _vm._i(props.row.isApe, null) > -1 : (props.row.isApe)
          },
          on: {
            "change": [function($event) {
              var $$a = props.row.isApe,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (props.row.isApe = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (props.row.isApe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.$set(props.row, "isApe", $$c)
              }
            }, function($event) {
              _vm.setChecked(props.row.culturalResourceId, props.row.isApe)
            }]
          }
        })])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(!_vm.formDisabled) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteRecording(props.row)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (!_vm.formDisabled || _vm.hasShpoRcDeskReview) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        _vm.saveExisting()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary form-control pull-right",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.crSelectionLoading
    },
    on: {
      "click": function($event) {
        _vm.addFileSearchSnrSites()
      }
    }
  }, [_vm._v("Add File Search Sites")])]) : _vm._e()], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Added Sites"
    }
  }, [_c('v-client-table', {
    ref: "newSiteTable",
    attrs: {
      "data": _vm.newSiteList,
      "columns": _vm.siteListGridSpecColumns,
      "options": _vm.siteListGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.hasWorkflow && (!_vm.formDisabled || _vm.isShpoCrNorm || _vm.hasShpoRcDeskReview)),
            expression: "props.row.hasWorkflow && (!formDisabled || isShpoCrNorm || hasShpoRcDeskReview)"
          }],
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "recordingType",
      fn: function(props) {
        return [_c('div', [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.recordingTypeId),
            expression: "props.row.recordingTypeId"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": props.row.recordingTypeId ? _vm.formDisabled : (_vm.formDisabled && !_vm.isShpoCrNorm && !_vm.hasShpoRcDeskReview)
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(props.row, "recordingTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, function($event) {
              _vm.markNew(props.row, $event)
            }]
          }
        }, [_c('option', {
          attrs: {
            "value": "",
            "disabled": ""
          }
        }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.recordingTypeList), function(recordingType) {
          return _c('option', {
            key: recordingType.id,
            attrs: {
              "disabled": _vm.optionIsDisabled(recordingType.id)
            },
            domProps: {
              "value": recordingType.id
            }
          }, [_vm._v("\n                                        " + _vm._s(recordingType.description) + "\n                                    ")])
        }), _vm._v(" "), (props.row.recordingTypeId === _vm.recordingTypeEnum.FirstRecording) ? _c('option', {
          domProps: {
            "value": _vm.recordingTypeEnum.FirstRecording
          }
        }, [_vm._v("\n                                        " + _vm._s('First Recording') + "\n                                    ")]) : _vm._e()], 2)])]
      }
    }, {
      key: "isApe",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.isApe),
            expression: "props.row.isApe"
          }],
          attrs: {
            "type": "checkbox",
            "disabled": (props.row.recordingTypeId === 7) || _vm.formDisabled
          },
          domProps: {
            "checked": Array.isArray(props.row.isApe) ? _vm._i(props.row.isApe, null) > -1 : (props.row.isApe)
          },
          on: {
            "change": [function($event) {
              var $$a = props.row.isApe,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (props.row.isApe = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (props.row.isApe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.$set(props.row, "isApe", $$c)
              }
            }, function($event) {
              _vm.setChecked(props.row.culturalResourceId, props.row.isApe)
            }]
          }
        })])]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteRecording(props.row)
            }
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.crrValidationResult && _vm.crrValidationResult.messages && _vm.crrValidationResult.messages.length > 0),
      expression: "crrValidationResult && crrValidationResult.messages && crrValidationResult.messages.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Error on delete:")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.crrValidationResult.messages), function(message) {
    return _c('li', {
      key: message
    }, [_vm._v(_vm._s(message))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.formDisabled || _vm.isShpoCrNorm || _vm.hasShpoRcDeskReview) ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        _vm.saveNew()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (!_vm.formDisabled || _vm.isShpoCrNorm || _vm.hasShpoRcDeskReview) ? _c('button', {
    staticClass: "btn btn-primary form-control pull-right",
    staticStyle: {
      "width": "95px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showSearch()
      }
    }
  }, [_vm._v("Add New")]) : _vm._e()])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Isolated Resources"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [(!_vm.formDisabled) ? _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("File Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Curation Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Field Number")]), _vm._v(" "), (!_vm.formDisabled) ? _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.isolateList), function(isolate) {
    return _c('tr', {
      key: isolate.isolateId
    }, [(!_vm.formDisabled) ? _c('td', [_c('router-link', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "font-size": "16px"
      },
      attrs: {
        "to": {
          path: '/Isolate/' + isolate.isolateId
        },
        "tag": "a"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(isolate.isolateNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(isolate.isolateCurationId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(isolate.resourceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(isolate.fieldNumber))]), _vm._v(" "), (!_vm.formDisabled) ? _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.deleteIsolate(isolate)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isolateList.length === 0),
      expression: "isolateList.length === 0"
    }]
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v(" No matching records ")])])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isolateValidationResult && _vm.isolateValidationResult.messages && _vm.isolateValidationResult.messages.length > 0),
      expression: "isolateValidationResult && isolateValidationResult.messages && isolateValidationResult.messages.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Error on delete:")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.isolateValidationResult.messages), function(message) {
    return _c('li', {
      key: message
    }, [_vm._v(_vm._s(message))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.formDisabled) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.goIsolate()
      }
    }
  }, [_vm._v("Add Isolated Resource")]) : _vm._e()])]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "In Progress Site Number Requests"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.snrGridSpec.tableData,
      "columns": _vm.snrGridSpec.columns,
      "options": _vm.snrGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/SiteNumberRequest/' + props.row.siteNumberRequestId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('modal', {
    ref: "culturalResourceSearchModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cultural Resource Search")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Smithsonian Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crSearchDto.smithsonianNumber),
      expression: "crSearchDto.smithsonianNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.crSearchDto.smithsonianNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crSearchDto, "smithsonianNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Site Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crSearchDto.siteName),
      expression: "crSearchDto.siteName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.crSearchDto.siteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crSearchDto, "siteName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', {
    staticClass: "control-label text-label",
    attrs: {
      "for": "crShowInactive"
    }
  }, [_vm._v("Show Inactive")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crSearchDto.showInactive),
      expression: "crSearchDto.showInactive"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "15px",
      "height": "15px"
    },
    attrs: {
      "type": "checkbox",
      "id": "crShowInactive"
    },
    domProps: {
      "checked": Array.isArray(_vm.crSearchDto.showInactive) ? _vm._i(_vm.crSearchDto.showInactive, null) > -1 : (_vm.crSearchDto.showInactive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.crSearchDto.showInactive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.crSearchDto.showInactive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.crSearchDto.showInactive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.crSearchDto, "showInactive", $$c)
        }
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.crSearchLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.searchGridSpec.tableData.length > 0) ? _c('div', {
    staticClass: "well"
  }, [(_vm.showAddMessage) ? _c('div', {
    attrs: {
      "id": "addMessage"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.showAddMessage))])]) : _vm._e(), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.searchGridSpec.tableData,
      "columns": _vm.searchGridSpec.columns,
      "options": _vm.searchGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "add",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-plus",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "disabled": _vm.showAddMessage
          },
          on: {
            "click": function($event) {
              _vm.addCulturalResourceRecording(props.row.culturalResourceId)
            }
          }
        })])]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.noSearchResults) ? _c('div', [_vm._v("\n                        No Cultural Resources found\n                    ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonSearch"
    },
    on: {
      "click": function($event) {
        _vm.searchCulturalResource()
      }
    }
  }, [_vm._v(" Search ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['culturalResourceSearchModal'].close()
      }
    }
  }, [_vm._v(" Close ")])])])])], 1), _vm._v(" "), (_vm.isDebug) ? _c('div', [_c('h2', [_vm._v("**Debug**")]), _vm._v("\n        " + _vm._s(_vm.selectedRecordingList) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2b6b12e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CulturalResourceSelection.vue
// module id = 998
// module chunks = 1